(() => {
  'use strict';
  const root = document.body.dataset.root || '/';

  function init(scope = document) {
    scope.querySelectorAll('[data-range-product]:not([data-range-ready])').forEach(pdp => {
      pdp.dataset.rangeReady = 'true';
      const variants = JSON.parse(pdp.querySelector('[data-range-variants]')?.textContent || '[]');
      const form = pdp.querySelector('.rg-form');
      const idInput = form.querySelector('[data-range-variant]');
      const add = form.querySelector('[data-range-add]');
      const stickyAdd = pdp.querySelector('[data-range-sticky-add]');
      const status = form.querySelector('[data-range-status]');
      const price = pdp.querySelector('[data-range-price]');
      const compare = pdp.querySelector('[data-range-compare]');
      const stickyPrice = pdp.querySelector('[data-range-sticky-price]');
      const stickyLabel = pdp.querySelector('[data-range-sticky-label]');
      const purchaseEnabled = pdp.dataset.purchaseEnabled === 'true';
      const currency = pdp.dataset.currency || 'USD';
      let busy = false;

      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format((Number(cents) || 0) / 100);
      const selectedOptions = () => [...form.querySelectorAll('[data-option-position]')].map(fieldset => fieldset.querySelector('input:checked')?.value);
      const selectedVariant = () => {
        if (!variants.length) return null;
        if (!form.querySelector('[data-option-position]')) return variants.find(v => String(v.id) === idInput.value) || variants[0];
        const choices = selectedOptions();
        return variants.find(v => v.options.every((option, index) => option === choices[index])) || null;
      };
      const isReady = variant => Boolean(variant && purchaseEnabled && variant.available && variant.sku && Number(variant.price) > 0);

      function reflect() {
        const variant = selectedVariant();
        const ready = isReady(variant);
        idInput.value = variant?.id || '';
        idInput.disabled = !variant;
        price.textContent = variant && Number(variant.price) > 0 ? money(variant.price) : 'Coming soon';
        if (stickyPrice) stickyPrice.textContent = price.textContent;
        if (variant && Number(variant.compare_at_price) > Number(variant.price)) {
          compare.hidden = false;
          compare.textContent = money(variant.compare_at_price);
        } else {
          compare.hidden = true;
          compare.textContent = '';
        }
        if (stickyLabel) stickyLabel.textContent = variant?.title || 'Choose options';
        [add, stickyAdd].forEach(button => {
          if (!button) return;
          button.disabled = !ready || busy;
          button.textContent = busy ? 'Adding…' : ready ? 'Add to bag' : 'Currently unavailable';
          button.setAttribute('aria-busy', String(busy));
        });
        if (!busy) status.textContent = ready
          ? 'Available for your selected destination.'
          : 'This configuration is not currently available in the US store. Contact SOTHING for availability updates.';
      }

      form.querySelectorAll('[data-option-position] input').forEach(input => input.addEventListener('change', reflect));
      reflect();

      form.addEventListener('submit', async event => {
        event.preventDefault();
        const variant = selectedVariant();
        if (!isReady(variant) || busy) {
          status.textContent = 'This configuration is not ready to purchase yet.';
          return;
        }
        const quantity = Number(form.elements.quantity.value);
        if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) {
          status.textContent = 'Choose a whole quantity between 1 and 99.';
          return;
        }
        busy = true;
        status.textContent = 'Adding to your bag…';
        reflect();
        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variant.id), quantity }] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Could not add this item. Please try again.');
          const cartResponse = await fetch(root + 'cart.js');
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-cart-count]').forEach(element => { element.textContent = cart.item_count; });
          }
          status.replaceChildren(document.createTextNode('Added to your bag. '));
          const link = document.createElement('a');
          link.href = root + 'cart?view=store-draft';
          link.textContent = 'View bag →';
          status.append(link);
        } catch (error) {
          status.textContent = error.message;
        } finally {
          busy = false;
          reflect();
        }
      });
    });
  }

  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

